<template>
  <b-tabs fill justified pills class="mt-7 mb-4">
    <div v-for="option in Options" :key="option.id">
      <b-tab
        :title="option.text + (option.count!=null ? ' ('+option.count+ ')' : '')"
        @click="onChange(Options, option.value)">
      </b-tab>
    </div>
  </b-tabs>
</template>

<script>
import httpHelper from "../helpers/httpHelper";
import sessionHelper from "../helpers/sessionHelper";
import { GET_NOTIFICATION_LIST } from "@/core/services/store/getNotification.module";

export default {
  name: "MDDropdown",
  props: ["group", "value", "parent"],
  data: function () {
    return {
      data: [],
      Options: [],
      item: null,
      itemCount: [],
    };
  },
  watch: {
    value: function (newVal, oldVal) {
      this.item = this.value;
    },
    parent: function (newVal, oldVal) {
      this.getOptions();
    },
    group() {
      this.getData();
    },
    loadedNotificationList(){
      if(this.$route.fullPath == "/tickets"){
        this.Options[0].count = this.loadedNotificationList.noteficationCount + this.loadedNotificationList.workingTicketCount;
        this.Options[1].count = this.loadedNotificationList.workingTicketCount ;
      }
    }
  },
  mounted() {
    this.getData();
    this.getNotification();
  },
  computed: {
    loadedNotificationList(){
      return this.$store.getters.loadedNotificationList;
    }
  },
  methods: {
    getNotification(){
      this.$store.dispatch(GET_NOTIFICATION_LIST);
    },
    onChange(options, event) {
      if (this.group == 120) {
        let opt = options.filter((v) => v.value == event);
        this.$emit("input", opt);
      } else {
        this.$emit("input", event);
      }
      this.$emit("LoadData", 1, false);
    },
    getOptions() {
      if (this.parent != null && this.parent != 0) {
        this.Options = [];
        this.data.forEach((element) => {
          if (element.parent == this.parent) {
            this.Options.push(element);
          }
        });
      } else {
        this.Options = this.data;
      }
      this.Options.push({ parent: null, value: null, text: "انتخاب نشده" });
      this.onChange(this.Options, this.Options[0].value);
      if(this.$route.fullPath == "/tickets"){
        this.Options[0].count = this.loadedNotificationList.noteficationCount + this.loadedNotificationList.workingTicketCount;
        this.Options[1].count = this.loadedNotificationList.workingTicketCount ;
      }
    },
    getData() {
      httpHelper
        .getData("metadata?metadata_group_id=" + this.group)
        .then((res) => {
          this.data = res.result.map((element) => {
            return {
              parent: element.parent_id,
              value: element.id,
              text: element.title,
              description: element.description,
              count: null,
            };
          });
          if (this.value) this.item = this.value;
          this.getOptions();
        });
    },
  },
};
</script>
<style scoped>
::v-deep .nav.nav-pills .nav-link {
  color: black;
}
::v-deep .nav.nav-pills .nav-link.active {
  color: white;
  font-weight: 900;
  background: linear-gradient(45deg, #ff998b 0%, #ff6d88 100%);
}
::v-deep .nav-link{
    white-space: nowrap;
}
</style>
